import presets from '@/store/dicts/presets';
import isPresetEnabled from '@/store/helpers/isPresetEnabled';

/**
 * Remove instâncias desativadas com base no isEnabled
 *
 * @param {*} loadedPage - Página completa.
 * @param {*} state - O estado atual da store.
 * @param {*} getters - Os getters da store.
 * @returns Objeto com a instances e instanceList atualizados.
 */
function removeDisabledInstances(loadedPage, state, getters) {
  const page = loadedPage;

  const instanceList = loadedPage.instanceList.filter((instanceId) => {
    const matchingPreset = presets.find(
      (preset) => preset.module === page.instances[instanceId].module,
    );

    if (!matchingPreset) {
      delete page.instances[instanceId];
      return false;
    }

    const isEnabled = isPresetEnabled(matchingPreset, state, getters);
    if (isEnabled) {
      return true;
    }

    delete page.instances[instanceId];
    return false;
  });

  return { instances: page.instances, instanceList };
}

export default removeDisabledInstances;
